import { render, staticRenderFns } from "./customer-info.vue?vue&type=template&id=0034ddcc"
import script from "./customer-info.vue?vue&type=script&lang=js"
export * from "./customer-info.vue?vue&type=script&lang=js"
import style0 from "./customer-info.vue?vue&type=style&index=0&id=0034ddcc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports